<template>
  <div>
    <div
      style="width: 1190px; margin: 0px auto; scroll-behavior: smooth"
      id="home"
    >
      <div
        class="dt"
        style="margin-left: -60px"
        v-show="dtShow"
        :class="[`a${activeIndex}`]"
      >
        <a @click="jump('a1')">
          <div class="dt-name" :class="{ dting: leftIndex === 'a1' }">
            解决方案
          </div>
        </a>
        <a @click="jump('a2')">
          <div class="dt-name" :class="{ dting: leftIndex === 'a2' }">
            专业服务
          </div>
        </a>
        <a @click="jump('a3')">
          <div class="dt-name" :class="{ dting: leftIndex === 'a3' }">
            热卖产品
          </div>
        </a>
        <a
          @click="jump('a' + (index + 4))"
          v-for="(item, index) in homepageList"
          :key="index"
        >
          <div
            class="dt-name"
            :class="{ dting: leftIndex === 'a' + (index + 4) }"
          >
            {{ item.titleName }}
          </div>
        </a>
        <a>
          <div :class="{ dting: leftIndex === 'a100' }">
            <a
              @click="$consultJump($store.state.user)"
              class="consult"
              >在线咨询</a
            >
          </div>
        </a>
        <!-- <a @click="jump('a0')">
          <div class="dt-up">
            <img src="~@/assets/img/up.jpg" alt="向上" />
          </div>
        </a> -->
      </div>
      <div class="bodyWidth" style="margin: 0">
        <el-carousel arrow="never" class="banner" height="443px">
          <el-carousel-item v-for="(item, index) in fiveSDataList" :key="index">
            <div
              class="demo111"
              data-key="5S"
              :data-id="item.id"
              @click="get5sDetail(item)"
            >
              <img :src="item.url && `${item.url}?x-oss-process=image/resize,m_mfit,w_940/quality,q_100/format,jpg`" :alt="item.name" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 网站公告管理 -->
      <div class="ell_one webAnnouncement rf" v-if="managment && managment.webAnnouncement && managment.webAnnouncement.announcementContent">
        {{ $t('home.notice') }}：&nbsp;&nbsp;&nbsp;
        <div class="flex-1"  :title="managment.webAnnouncement.announcementContent">
          <van-notice-bar :text="managment.webAnnouncement.announcementContent" :scrollable="true" speed="40" />
        </div>
      </div>
      <!-- 活动 -->
      <div ref="" class="" v-if="showActivity">
        <el-row :gutter="10" class="panicBuying">
          <div class="panicBuying-sign box-shadow" @click="goPanicBuying()">
            <img :src="promotionUrl" height="260px" width="209px" :alt="$t('common.default')" />
          </div>
          <div class="panicBuying-car">
            <el-carousel
              :interval="5000"
              arrow="always"
              indicator-position="none"
              height="260"
            >
              <el-carousel-item
                v-for="(items, indexs) in Math.ceil(panicBuyingList.length / 4)"
                :key="indexs"
                class="panicBuying-carousel"
              >
                <el-col
                  :span="6"
                  v-for="(item, index) in panicBuyingList.slice(
                    4 * indexs,
                    4 * indexs + 4
                  )"
                  :key="index"
                >
                  <div class="goodInfo">
                    <div
                      class="goodInfo-right-border"
                      v-show="index % 4 !== 0"
                    ></div>
                    <img
                      v-lazy="item.fileUrl"
                      width="203px"
                      height="152px"
                      class="goodInfo-img"
                      @click="goodDetail(item.spuId)"
                    />
                    <div class="goodName overell">{{ item.commodityName }}</div>
                    <div class="panicBuying-price">
                      <div class="price-left">
                        {{ $t('common.currency') }}<font class="price-left-amount">{{
                          item.promotionSalePrice.toFixed(2)
                        }}</font>
                      </div>
                      <div class="price-right">
                        {{ $t('common.currency') }}<font class="price-right-amount">{{
                          item.sellingPrice.toFixed(2)
                        }}</font>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-row>
      </div>
      <!-- 解决方案 -->
      <div ref="a1">
        <el-container>
          <el-col :span="6" class="titleMart">
            <!-- <a id="a1"></a> -->
            <span class="title">解决方案</span>
            <span class="stitle">宁东工业超市生态 专业视角</span>
          </el-col>
          <el-col :span="18">
            <div>
              <span class="plan" @click="goPlanList"> 更多 > </span>
            </div>
            <span
              v-for="(soluItem, index) in soluList"
              :key="index"
              class="plan"
              :class="{ planac: soluIndex == index }"
              @click="chooseSolu(index)"
              :title="soluItem.name"
              >{{ soluItem.name }}</span
            >
          </el-col>
        </el-container>
        <el-container class="box-shadow">
          <swiper
            ref="solutionRef"
            :options="swiperOption1"
            v-if="
              soluIndex > -1 &&
              soluList[soluIndex] &&
              soluList[soluIndex].childFormatList &&
              soluList[soluIndex].childFormatList.length
            "
            style="padding-left: 10px; padding-right: 10px; width: 100%"
          >
            <swiper-slide
              style="height: auto"
              v-for="(items, indexs) in soluList[soluIndex].childFormatList"
              :key="indexs"
            >
              <el-col
                :span="8"
                class="plan-box-m"
                v-for="(item, index) in items"
                :key="index"
              >
                <div class="imgBox">
                  <img
                    v-if="indexs === 0"
                    :src="item.thumbnailUrl && `${item.thumbnailUrl}?x-oss-process=image/resize,m_mfit,w_370/quality,q_100/format,jpg`"
                    :alt="item.name"
                    width="100%"
                    height="200px"
                    data-key="solu"
                    :data-index="soluIndex"
                    :data-inds="index + 3 * indexs"
                    @click.stop="
                      planDetail(soluIndex, index + 3 * indexs, item.id, item.sceneId)
                    "
                    :data-name="item.name"
                  />
                  <img
                    v-else
                    v-lazy="item.thumbnailUrl && `${item.thumbnailUrl}?x-oss-process=image/resize,m_mfit,w_370/quality,q_100/format,jpg`"
                    :alt="item.name"
                    width="100%"
                    height="200px"
                    data-key="solu"
                    :data-index="soluIndex"
                    :data-inds="index + 3 * indexs"
                    :data-name="item.name"
                    @click.stop="
                      planDetail(soluIndex, index + 3 * indexs, item.id, item.sceneId)
                    "
                  />
                </div>
                <div class="plan-title overell">{{ item.name }}</div>
                <div class="plan-stitle plan-stitle-over">{{ item.desc }}</div>
                <div class="plan-stitle-border"></div>
                <div
                  class="plan-more"
                  data-key="solu"
                  :data-index="soluIndex"
                  :data-name="item.name"
                  @click.stop="
                    planDetail(soluIndex, index + 3 * indexs, item.id, item.sceneId)
                  "
                  :data-inds="index + 3 * indexs"
                >
                  查看详情
                </div>
                <div></div>
              </el-col>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </el-container>
      </div>
      <!-- 专业服务 -->
      <div ref="a2">
        <el-container>
          <el-col :span="6" class="titleMart">
            <span class="title">专业服务</span>
            <span class="stitle">宁东工业超市打造 以近智动</span>
          </el-col>
          <el-col :span="18" class="server-more">
            <div>
              <span class="plan" @click="goServiceList"> 更多 > </span>
            </div>
          </el-col>
        </el-container>
        <div class="box-shadow serve">
          <div style="width: 1190px" class="fl">
            <el-col
              :span="6"
              :class="index === serviceIndex ? 'servetabactive' : ''"
              v-for="(serItem, index) in serviceList"
              :key="index"
              class="serve-tab"
              @click="chooseCervice(index)"
            >
              <span
                style="display: block; width: 100%; height: 100%"
                @click="chooseCervice(index)"
                >{{ serItem.name }}</span
              >
            </el-col>
          </div>
          <div style="width: 100%" class="serve-box fl">
            <swiper :options="swiperOptionSer" v-if="showService">
              <!-- v-if="showService" -->
              <swiper-slide
                style="height: 170px"
                v-for="(servItem, index) in !!serviceList[serviceIndex].children
                  ? serviceList[serviceIndex].children
                  : []"
                :key="index"
              >
                <div class="serve-box-img fl imgAuto">
                  <img
                    v-if="index === 0"
                    :src="servItem.thumbnailUrl || ''"
                    :alt="servItem.name"
                  />
                  <img
                    v-else
                    v-lazy="servItem.thumbnailUrl || ''"
                    :alt="servItem.name"
                  />
                </div>
                <div class="serve-box-title">
                  <span class="serve-box-title-span">{{ servItem.name }}</span>
                </div>
                <div class="serve-box-con">
                  <span class="serve-box-des-span">{{
                    spliceString(servItem.desc)
                  }}</span>
                </div>
                <div
                  class="serve-box-more"
                  @click="serviceDetail(serviceIndex, index)"
                >
                  <!-- @click="serviceDetail(serviceIndex,index)" -->
                  <span
                    class="blu"
                    data-key="service"
                    :data-index="serviceIndex"
                    :data-inds="index"
                    :data-name="servItem.name"
                    >查看详情 ></span
                  >
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
      <!-- 热卖 -->
      <div ref="a3">
        <el-container>
          <el-col :span="12" class="titleMart">
            <span class="title">{{ $t('home.hotsale') }}</span>
            <span class="stitle">{{ $t('home.hotsale2') }}</span>
          </el-col>
          <el-col :span="12" class="server-more">
            <router-link :to="{ name: 'bestGoodsList' }">
              <span class="plan"> {{ $t('common.more') }} > </span>
            </router-link>
          </el-col>
        </el-container>
        <el-row :gutter="10">
          <el-col class="rem">
            <div style="width: 100%; height: 100%" class="box-shadow">
              <swiper
                :options="swiperOption"
                v-if="bestSellersAdvList && bestSellersAdvList.length > 0"
              >
                <swiper-slide
                  class="swiper-slide imgAuto"
                  style="height: 291px; width: 230px"
                  v-for="(item, index) in bestSellersAdvList"
                  data-key="good"
                  :data-goodKey="item.commodityKey"
                  :data-spuId="item.commoditySpuId"
                  :data-name="item.commodityName"
                  :key="index"
                >
                  <img
                    :src="item.photoUrl"
                    style="height: 291px; width: 230px"
                    :alt="item.commodityName"
                    data-key="good"
                    :data-goodKey="item.commodityKey"
                    :data-spuId="item.commoditySpuId"
                    :data-name="item.commodityName"
                  />
                </swiper-slide>
              </swiper>
              <img
                v-else
                src="~@/assets/img/repic.jpg"
                height="291px"
                width="230px"
                alt="默认"
              />
            </div>
          </el-col>
          <el-col
            class="rems"
            v-for="(item, index) in bestSellersTypes"
            :key="index"
          >
            <div
              style="width: 100%; height: 100%; cursor: pointer"
              class="box-shadow"
              @click="bestGoodType(item)"
            >
              <div class="rems-box">
                <el-col class="rems-title overell">{{ item.name }}</el-col>
              </div>
              <div class="rems-box">
                <el-col class="rems-desc overell">{{ item.describe }}</el-col>
              </div>
              <div class="rem-img imgAuto">
                <img v-lazy="item.typeUrl||'~@/assets/img/repic.jpg'"
                     :alt="item.name"
                     class="fit-contain" />
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 楼层 -->
      <div
        v-for="(item, floIndex) in homepageList"
        :key="floIndex"
        ref="homeRefs"
      >
        <!-- 楼层1 -->
        <div v-if="item.templateCode === 1">
          <el-container>
            <el-col
              :span="24"
              class="titleMart overell"
            >
              <span class="title">{{ item.titleName }}</span>
              <span class="stitle">{{ item.describes }}</span>
            </el-col>
          </el-container>
          <el-row
            class="box-shadow"
            v-if="
              item.homePageCategoryCommodityVoList &&
              item.homePageCategoryCommodityVoList.length > 0
            "
          >
            <div class="xianc1 fl">
              <div
                class="xiancltitle"
                :class="{ xiancltitleac: fzIndex == index }"
                v-for="(catItm, index) in item.homePageCategoryCommodityVoList"
                :key="index"
                @click="homeOneClickCate(floIndex, index, item.templateCode)"
              >
                {{ catItm.categoryName }}
              </div>
            </div>
            <div v-if="showFirstFloor(floIndex)">
              <div
                class="xianc2 fl"
                v-for="(goodsItem, index) in item.showFirstGoods"
                :key="index"
                v-show="goodsItem.commoditySpuVo"
                style="cursor: pointer"
                @click="goodDetail(goodsItem.commoditySpuId)"
              >
                <div class="xianc2-pic">
                  <div
                    style="position: absolute; left: 0; top: 0; z-index: 1"
                    v-if="goodsItem.commoditySpuVo && goodsItem.commoditySpuVo.tagNameList && goodsItem.commoditySpuVo.tagNameList.length"
                  >
                    <el-tag
                      v-for="(itm, idx) in goodsItem.commoditySpuVo.tagNameList"
                      :key="idx"
                      size="mini"
                      style="margin-right: 3px"
                      type="danger"
                      effect="dark"
                    >
                      {{ itm }}
                    </el-tag>
                  </div>
                  <img v-lazy="goodsItem.commodityUrl"
                       width="220px"
                       height="180px"
                       :alt="goodsItem.commoditySpuVo.name"
                       class="fit-contain" />
                </div>
                <div
                  class="xianc2-title overell"
                  :title="goodsItem.commoditySpuVo.name"
                >
                  {{ goodsItem.commoditySpuVo.name }}
                </div>
                <div class="overell fmbox-l">
                  {{ goodsItem.commoditySpuVo.description }}
                </div>
                <div class="overell fmbox-l" v-if="goodsItem.commoditySpuVo">
                  {{ $t('common.brandName') }}：{{ goodsItem.commoditySpuVo.brandInfo.name }}
                </div>
                <div class="overell fmbox-l" v-if="goodsItem.commoditySpuVo">
                  {{ $t('common.collection') }}：{{ goodsItem.commoditySpuVo.seriesInfo.name }}
                </div>
                <div
                  class="overell fmbox-l"
                  v-if="
                    goodsItem.commoditySpuVo &&
                    goodsItem.commoditySpuVo.skuInfoList.length > 0
                  "
                >
                  {{ $t('common.model') }}：{{ goodsItem.commoditySpuVo.skuInfoList[0].model }}
                </div>
                <div v-show="false">
                  {{ goodsItem.commoditySpuVo && goodsItem.commoditySpuVo.commodityType }}
                  <br />
                  {{ goodsItem.commoditySpuVo && goodsItem.commoditySpuVo.minPrice }}
                  <br />
                  {{ goodsItem.commoditySpuVo && goodsItem.commoditySpuVo.isSellingPriceExpire }}
                </div>
                <div
                  class="overell fmbox-l"
                  v-if="
                    goodsItem.commoditySpuVo &&
                    goodsItem.commoditySpuVo.minPrice &&
                    !goodsItem.commoditySpuVo.isSellingPriceExpire
                  "
                >
                  <good-price
                    :price="Number(goodsItem.commoditySpuVo.minPrice) || 0"
                  ></good-price>
                </div>
                <div
                  class="overell fmbox-l"
                  v-if="
                    (goodsItem.commoditySpuVo &&
                    !goodsItem.commoditySpuVo.minPrice) ||
                    (goodsItem.commoditySpuVo && goodsItem.commoditySpuVo.isSellingPriceExpire)
                  "
                >
                  {{$t('common.price')}}：{{$t('home.rfq')}}
                </div>
              </div>
            </div>
          </el-row>
          <el-row
            :gutter="10"
            v-if="
              item.homePageAdvertisementBrandVoList &&
              item.homePageAdvertisementBrandVoList.length
            "
          >
            <el-col
              class="xclogo"
              v-for="(
                homeBrand, index
              ) in item.homePageAdvertisementBrandVoList.slice(0, 7)"
              :key="index"
            >
              <img
                v-lazy="homeBrand.brandUrl"
                :alt="homeBrand.name"
                style="cursor: pointer"
                @click="getgoodsByBrand(homeBrand.brandId)"
              />
            </el-col>
          </el-row>
        </div>
        <!-- 楼层2 -->
        <div v-else-if="item.templateCode === 2">
          <el-row>
            <el-col
              :span="24"
              class="titleMart overell"
            >
              <span class="title">{{ item.titleName }}</span>
              <span class="stitle">{{ item.describes }}</span>
            </el-col>
          </el-row>
          <el-row>
            <div class="fmgg fl" style="display: block">
              <img
                style="height: 394px; width: 215px"
                v-if="item.homePageAdvertisementInfoVoList.length === 0"
                src="../../assets/img/占位图.png"
                class="img-cn"
                alt="占位图"
              />
              <img
                style="height: 394px; width: 215px"
                v-if="item.homePageAdvertisementInfoVoList.length === 0"
                src="../../assets/img/占位图_en.png"
                class="img-en"
                alt="占位图"
              />
              <swiper :options="swiperOption">
                <swiper-slide
                  style="height: 394"
                  v-for="(
                    itemAdv, index
                  ) in item.homePageAdvertisementInfoVoList"
                  @click="goodDetail(itemAdv.commoditySpuId)"
                  :key="index"
                >
                  <div
                    :style="'width:100%;'"
                    data-key="good"
                    :data-name="itemAdv.commodityName"
                    :data-spuId="itemAdv.commoditySpuId"
                  >
                    <img
                      :src="itemAdv.photoUrl"
                      :alt="itemAdv.commodityName"
                      width="215px"
                      height="394px"
                      data-key="good"
                      :data-spuId="itemAdv.commoditySpuId"
                      :data-name="itemAdv.commodityName"
                    />
                  </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
            <div
              style="width: 804px"
              class="fl"
              v-if="
                item.homePageCategoryCommodityVoList &&
                item.homePageCategoryCommodityVoList.length
              "
            >
              <div
                class="fmbox box-shadow fl"
                v-for="(
                  goodItem, index
                ) in item.homePageCategoryCommodityVoList.slice(0, 6)"
                :key="index"
                style="cursor: pointer"
                @click="goodDetail(goodItem.commoditySpuId)"
              >
                <div style="width: 146px" class="fl">
                  <div
                    class="overell fmbox-title"
                    :title="goodItem.commodityName"
                  >
                    {{ goodItem.commodityName }}
                  </div>
                  <div class="overell fmbox-l" v-if="goodItem.commoditySpuVo">
                    {{ goodItem.commoditySpuVo.description }}
                  </div>
                  <div class="overell fmbox-l" v-if="goodItem.commoditySpuVo">
                    {{ $t('common.brandName') }}：{{ goodItem.commoditySpuVo.brandInfo.name }}
                  </div>
                  <div
                    class="overell fmbox-l"
                    v-if="
                      goodItem.commoditySpuVo &&
                      goodItem.commoditySpuVo.skuInfoList.length > 0
                    "
                  >
                    {{ $t('common.model') }}：{{ goodItem.commoditySpuVo.skuInfoList[0].model }}
                  </div>
                  <div class="overell fmbox-l" v-if="goodItem.commoditySpuVo">
                    {{ $t('common.collection') }}：{{ goodItem.commoditySpuVo.seriesInfo.name }}
                  </div>
                  <div class="overell fmbox-l" v-if="goodItem.commoditySpuVo">
                    <span
                      class="price price_text"
                      v-show="
                        goodItem.commoditySpuVo.commodityType &&
                        goodItem.commoditySpuVo.commodityType.indexOf('非标') > -1 ||
                        goodItem.commoditySpuVo.isSellingPriceExpire
                      "
                      >{{ $t('home.rfq') }}</span
                    >
                    <good-price
                      v-show="
                        goodItem.commoditySpuVo.commodityType &&
                        goodItem.commoditySpuVo.commodityType.indexOf(
                          '非标'
                        ) === -1 &&
                        !goodItem.commoditySpuVo.isSellingPriceExpire
                      "
                      :price="Number(goodItem.commoditySpuVo.minPrice) || 0"
                    ></good-price>
                  </div>

                  <div
                    style="margin-left: 8px"
                    v-if="goodItem.commoditySpuVo && goodItem.commoditySpuVo.tagNameList && goodItem.commoditySpuVo.tagNameList.length"
                  >
                    <el-tag
                      v-for="(itm, idx) in goodItem.commoditySpuVo.tagNameList"
                      :key="idx"
                      size="mini"
                      style="margin-right: 3px"
                      type="danger"
                      effect="dark"
                    >
                      {{ itm }}
                    </el-tag>
                  </div>
                  <!-- <div class="overell fmbox-l"
                       v-if="goodItem.commoditySpuVo">收藏：{{goodItem.commoditySpuVo.collectionCount}} 询价：{{goodItem.commoditySpuVo.inquirySheetCount}}</div> -->
                </div>
                <div class="fr xcyb-img imgAuto">
                  <img v-lazy="goodItem.commodityUrl"
                       :alt="goodItem.commodityName"
                       class="fit-contain" />
                </div>
              </div>
            </div>
            <div
              style="width: 160px"
              class="fr"
              v-if="
                item.homePageAdvertisementBrandVoList &&
                item.homePageAdvertisementBrandVoList.length
              "
            >
              <div
                class="fmlogo box-shadow"
                style="cursor: pointer"
                v-for="(
                  homeBrand, index
                ) in item.homePageAdvertisementBrandVoList.slice(0, 4)"
                :key="index"
                @click="getgoodsByBrand(homeBrand.brandId)"
              >
                <img v-lazy="homeBrand.brandUrl" :alt="homeBrand.name" />
              </div>
            </div>
          </el-row>
        </div>
        <!-- 楼层3 -->
        <div v-else>
          <el-row>
            <el-col class="titleMart overell" style="width: auto;">
              <span class="title">{{ item.titleName }}</span>
              <span class="stitle">{{ item.describes }}</span>
            </el-col>
            <el-col
              style="float: right; margin-bottom: 10px; width: auto;"
              v-if="
                item.homePageCategoryCommodityVoList &&
                item.homePageCategoryCommodityVoList.length
              "
            >
              <span
                v-for="(catItem, index) in item.homePageCategoryCommodityVoList"
                :key="index"
                class="plan"
                :class="{ planac: item.floIndexac == index }"
                @click="homeOneClickCate(floIndex, index, item.templateCode, item)"
                >{{ catItem.categoryName }}</span
              >
            </el-col>
          </el-row>
          <el-row>
            <div class="kzl fl">
              <img
                style="height: 632px; width: 215px"
                v-if="item.homePageAdvertisementInfoVoList.length === 0"
                src="static\img\占位图.png"
                alt="占位图"
                class="img-cn"
              />
              <img
                style="height: 632px; width: 215px"
                v-if="item.homePageAdvertisementInfoVoList.length === 0"
                src="static\img\占位图_en.png"
                alt="占位图"
                class="img-en"
              />
              <swiper
                :options="swiperOption"
                v-if="
                  item.homePageAdvertisementInfoVoList &&
                  item.homePageAdvertisementInfoVoList.length
                "
              >
                <swiper-slide
                  style="height: 394"
                  v-for="(
                    advItem, advIndex
                  ) in item.homePageAdvertisementInfoVoList"
                  :key="advIndex"
                >
                  <!-- @click="goodDetail(advItem.commoditySpuId)" -->
                  <div
                    :style="
                      'width:100%;' +
                      (advItem.commodityKey ? 'cursor:pointer;' : '')
                    "
                    data-key="good"
                    :data-goodKey="advItem.commodityKey"
                    :data-spuId="advItem.commoditySpuId"
                    :data-name="advItem.commodityName"
                  >
                    <img
                      v-if="advIndex === 0"
                      :src="advItem.photoUrl"
                      :alt="advItem.commodityName"
                      data-key="good"
                      :data-goodKey="advItem.commodityKey"
                      :data-name="advItem.commodityName"
                      :data-spuId="advItem.commoditySpuId"
                      width="215px"
                      height="632px"
                    />
                    <img
                      v-else
                      v-lazy="advItem.photoUrl"
                      :alt="advItem.commodityName"
                      data-key="good"
                      :data-goodKey="advItem.commodityKey"
                      :data-spuId="advItem.commoditySpuId"
                      :data-name="advItem.commodityName"
                      width="215px"
                      height="632px"
                    />
                  </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
            <div v-if="showFirstFloor(floIndex)">
              <div class="fl ker-box"
                   v-for="(goodItem,index) in item.showFirstGoods"
                   :key="index"
                   style="cursor:pointer;"
                   @click="goodDetail(goodItem.commoditySpuVo.spuId)">
                <div
                  style="position: absolute; left: 9px; top: 10px; z-index: 1"
                  v-if="goodItem.commoditySpuVo && goodItem.commoditySpuVo.tagNameList && goodItem.commoditySpuVo.tagNameList.length"
                >
                  <el-tag
                    v-for="(itm, idx) in goodItem.commoditySpuVo.tagNameList"
                    :key="idx"
                    size="mini"
                    style="margin-right: 3px"
                    type="danger"
                    effect="dark"
                  >
                    {{ itm }}
                  </el-tag>
                </div>
                <img v-lazy="goodItem.commodityUrl"
                     width="100%"
                     :alt="goodItem.commodityName"
                     class="fit-contain" />
                <div class="ker-title overell"
                     :title="goodItem.commodityName">{{goodItem.commodityName}}</div>
                <div class="overell fmbox-l"
                     v-if="goodItem.commoditySpuVo">{{ $t('common.brandName') }}：{{goodItem.commoditySpuVo.brandInfo.name}}</div>
                <div class="overell fmbox-l"
                     v-if="goodItem.commoditySpuVo">{{ $t('common.collection') }}：{{goodItem.commoditySpuVo.seriesInfo.name}}</div>
                <div class="overell fmbox-l"
                     v-if="goodItem.commoditySpuVo && goodItem.commoditySpuVo.skuInfoList.length > 0">{{ $t('common.model') }}：{{goodItem.commoditySpuVo.skuInfoList[0].model}}</div>
                <div v-show="false" id="test">
                  {{ goodItem.commoditySpuVo && goodItem.commoditySpuVo.commodityType }}
                  <br />
                  {{ goodItem.commoditySpuVo && goodItem.commoditySpuVo.minPrice }}
                  <br />
                  {{ goodItem.commoditySpuVo && goodItem.commoditySpuVo.isSellingPriceExpire }}
                </div>
                <div
                  class="overell fmbox-l"
                  v-if="
                    goodItem.commoditySpuVo &&
                    goodItem.commoditySpuVo.minPrice &&
                    !goodItem.commoditySpuVo.isSellingPriceExpire
                  "
                >
                  <good-price
                    :price="Number(goodItem.commoditySpuVo.minPrice) || 0"
                  ></good-price>
                </div>
                <div
                  class="overell fmbox-l"
                  v-if="
                    (goodItem.commoditySpuVo &&
                    !goodItem.commoditySpuVo.minPrice) ||
                    (goodItem.commoditySpuVo && goodItem.commoditySpuVo.isSellingPriceExpire)
                  "
                >
                  <span class="price price_text">{{$t('home.rfq')}}</span>
                </div>
              </div>
            </div>
          </el-row>
        </div>
      </div>
      <!-- 品牌 -->
      <el-row>
        <el-col :span="12" class="titleMart">
          <span class="title">{{ $t('common.brands') }}</span>
          <span class="stitle">{{ $t('home.brandsSettled') }}</span>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 50px">
        <el-carousel
          :interval="5000"
          height="136px"
          arrow="always"
          indicator-position="none"
        >
          <el-carousel-item
            v-for="(items, indexs) in Math.ceil(brandList.length / 7)"
            :key="indexs"
          >
            <el-row
              class="box-shadow"
              :gutter="10"
              style="padding-left: 60px; padding-right: 60px"
            >
              <el-col
                class="pplogo"
                v-for="(item, index) in brandList.slice(
                  7 * indexs,
                  7 * indexs + 7
                )"
                :key="index"
              >
                <el-col>
                  <!-- <img src="~@/assets/img/banner.jpg"> -->
                  <img
                    v-lazy="item.fileUrl"
                    :alt="item.name"
                    @click="getgoodsByBrand(item.brandId)"
                    style="cursor: pointer"
                  />
                </el-col>
              </el-col>
            </el-row>
          </el-carousel-item>
        </el-carousel>
      </el-row>
    </div>
  </div>
</template>
<script>
import GoodPrice from '@/components/good-price'
import '@/assets/scss/swiper/swiper.css' // 这里注意具体看使用的版本是否需要引入样式，以及具体位置。
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { openOther } from '@/utils/index'
import { spliceString, elementIsVisibleInViewport, scrollIntoView } from '@/utils'
// import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      allmenuList: [],
      lelve2menuList: [],
      current: '',
      menuright: false,
      bestSellersTypes: [], // 热卖品牌
      bestSellersAdvList: [], // 热卖广告列表
      brandList: [], // 品牌列表
      homepageList: [], // 品牌列表,
      homeOneTabIndex: -1, // 楼层一显示某类目下商品
      fiveSDataList: [], // 5S店轮播图,
      leftIndex: '',
      showActivity: false,
      height: '', // 记录模块楼层高度
      panicBuyingList: [], // 活动促销商品
      promotionUrl: '', // 促销活动图片
      promotionId: '',
      promotionCount: 0,
      serviceList: [], // 服务列表
      serviceIndex: 0,
      soluIndex: 0,
      soluList: [],
      fzIndex: 0,
      floIndexac: 0,
      dtShow: false, // 电梯是否显示
      // 设置属性
      swiperOption: {
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true // 允许分页点击跳转
        },
        // 自动轮播
        autoplay: {
          disableOnInteraction: false,
          delay: 4000
        },
        // 开启循环模式
        loop: true,
        // 开启鼠标滚轮控制Swiper切换
        mousewheel: false,
        on: {
          click: function (e) {}
        }
      },
      // 设置属性
      swiperOption1: {
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true // 允许分页点击跳转
        },
        // 自动轮播
        autoplay: {
          disableOnInteraction: false,
          delay: 4000
        },
        // 开启循环模式
        loop: false,
        // 开启鼠标滚轮控制Swiper切换
        mousewheel: false,
        on: {
          click: function (e) {}
        }
      },
      // 服务轮播设置
      swiperOptionSer: {
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // 自动轮播
        autoplay: {
          disableOnInteraction: false,
          delay: 4000
        },
        // 开启循环模式
        loop: true,
        // 开启鼠标滚轮控制Swiper切换
        mousewheel: false,
        on: {
          click: function (e) {}
        }
      },
      managment: {
        webAnnouncement: {
          announcementContent: ''
        }, // 公告
        linkList: [], // 友情链接
        onlineServe: { // 在线客服
          phone: ''
        },
        columnList: [] // 栏目
      },
      timer: null, // 滚动定时器
      activeIndex: -1 // 滚动时在视图中的模块序号
    }
  },
  methods: {
    // 获取哪些模块在视图里
    getVisible () {
      const visibleIndex = this.visibleIndex()
      if (visibleIndex.length >= 1) {
        this.$nextTick(() => {
          this.activeIndex = visibleIndex[0]
        })
      } else {
        this.activeIndex = -1
      }
    },
    // 返回视图内的相应序号
    visibleIndex () {
      let jumpArr = []
      let allSides = [this.$refs.a1, this.$refs.a2, this.$refs.a3]
      if (this.$refs.homeRefs) {
        this.$refs.homeRefs.forEach((item) => {
          const targetDom = item
          if (targetDom) {
            allSides.push(targetDom)
          }
        })
      }
      allSides.forEach((item, index) => {
        elementIsVisibleInViewport(item, true, 0, 240) && jumpArr.push(index)
      })
      return jumpArr
    },
    spliceString (str) {
      return spliceString(str, 195)
    },
    goShop (val) {
      this.$router.push({
        name: 'goodCategoryList',
        query: {
          foregroundCategoryId: val.foregroundCategoryId || ''
        }
      })
    },
    // 热卖id跳转
    bestGoodType (item) {
      this.$router.push({
        name: 'bestGoodsList',
        query: { id: item.bestSellersTypeId }
      })
    },
    // 进入商品详情页
    goodDetail (spuId, skuId) {
      openOther(`goodDetail?spuId=${spuId}`)
    },
    getgoodsByBrand (brandId) {
      this.$router.push({
        name: 'goodBrandCategoryList',
        query: {
          foregroundCategoryId: '',
          brandIdList: brandId + '',
          seriesIdList: '',
          attributeValueIdList: '',
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false,
          category: true
        }
      })
    },
    enter (val, index) {
      this.current = index
      this.menuright = true
      this.lelve2menuList = val.children
    },
    leave (val, index) {
      this.menuright = false
    },
    enter2 () {
      this.menuright = true
    },
    leave2 () {
      this.current = ''
      this.menuright = false
    },
    jump (domId) {
      let height =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      let num = (Number(domId.slice(1)) || 0) - 4
      if (num >= 0) {
        // 自定义楼层
        scrollIntoView(this.$refs.homeRefs[num], 0)
      } else {
        if (num === -4) { // 返回顶部
          this.height = -height
          scrollIntoView(document.body, 0)
        } else {
          // 固定楼层 1，2，3
          scrollIntoView(this.$refs[domId], 0)
        }
      }
    },

    // 获取热卖类目及热卖商品
    getBestSellersType () {
      this.$request
        .get(
          `/front/user/home/homeBestSellersType/findBestSellersTypesForShopping?mobileFlag=0`
        )
        .then((data) => {
          let typeList = []
          if (data.homeBestSellersTypeVos) {
            typeList =
              data.homeBestSellersTypeVos.length > 8
                ? data.homeBestSellersTypeVos.splice(0, 8)
                : data.homeBestSellersTypeVos
          }
          this.bestSellersTypes = typeList
          this.bestSellersAdvList =
            data.homeHotCommodityAdvertisementInfoVos || []
        })
    },
    // 获取5S店轮播图
    get5s () {
      this.$request
        .get(`/front/user/home/homeRotationChart/selectRotationChartList/1`, {
          // params: { detailed: false }
        })
        .then((data) => {
          this.fiveSDataList = data
        })
    },
    getHomepageList () {
      this.$request
        .postParam(`/front/user/home/homePageAdvertisement/selectAllDatas`, {
          mobiled: false
        })
        .then((data) => {
          let homepageList = data || []
          // let aIndex = []
          homepageList.forEach((item, index) => {
            item.homeOneTabIndex = item.homePageCategoryCommodityVoList.length
              ? 0
              : -1
            item.showFirstGoods = this.showFirstGoods(item)
            this.$set(item, 'floIndexac', 0)
            // aIndex.push(('a' + (index + 4)))
          })
          this.homepageList = homepageList
          this.dtShow = true
        })
    },
    getPanicBuyingList () {
      this.$request
        .get(`/front/order/payCommodityPromotion/selectActivityInfo/2`)
        .then((data) => {
          let panicBuyingList = []
          this.showActivity =
            data.promotionCount > 0 && data.commodityList.length > 0
          this.promotionUrl = data.pcPhotoUrl
          this.promotionCount = data.promotionCount
          this.promotionId = data.promotionId
          panicBuyingList = data.commodityList || []
          this.panicBuyingList = panicBuyingList
        })
        .catch(() => {
          this.panicBuyingList = []
        })
    },
    // 切换楼层一显示的商品
    homeOneClickCate (parIndex, index, type, item) {
      if (type === 1) {
        this.fzIndex = index
      } else {
        this.floIndexac = index
      }
      if (item) {
        this.$set(item, 'floIndexac', index)
      }
      this.homepageList[parIndex].homeOneTabIndex = index
      this.homepageList[parIndex].showFirstGoods = this.showFirstGoods(
        this.homepageList[parIndex]
      )
    },
    // 获取品牌
    getBrandList () {
      this.$request
        .get(`/front/cross/commodity-user/web/brand-list`)
        .then((data) => {
          this.brandList = data ? data.slice(0, 200) : []
        })
    },
    // 获取专业服务
    getAllSerivce () {
      this.$request
        .get(`/front/user/home/homeService/findParentLevelAndSubLevel`)
        .then((_data) => {
          this.serviceList = _data ? _data.slice(0, 4) : []
        })
    },
    // 跳转详情
    serviceDetail (parInd, index) {
      // let list = this.serviceAllChildren(this.serviceList[parInd].children)
      let list = this.serviceList[parInd].children
      let params = {
        key: list[index].name,
        id: list[index].serviceId
      }
      this.$router.push({ name: 'serviceContent', query: params })
    },
    getAllSolu () {
      this.$request
        .get(`/front/user/home/homeSolution/findParentLevelAndSubLevel`)
        .then(async (_data) => {
          let soluList = _data ? _data.slice(0, 6) : []

          // 商品场景化
          let scene = await this.$http.get(
            '/front/cross/commodity-user/sceneInfos'
          )
          let sd = scene.data.data
          if (sd && sd.list) {
            soluList = soluList.slice(0, 5)
            soluList.unshift({
              id: -1,
              name: '爆品合集',
              children: sd.list.map(
                v => ({
                  id: v.sceneId,
                  name: v.mainImgTitle,
                  desc: v.mainImgRemark,
                  thumbnailUrl: v.mainImg,
                  sceneId: v.sceneId
                })
              )
            })
          }

          let allList = []
          soluList.forEach((element) => {
            element.childFormatList = []
            if (element.children && element.children.length > 0) {
              element.children.forEach((ele) => {
                ele.parName = element.name
              })
              allList.push(...element.children)
              for (let i = 0; i < Math.ceil(element.children.length / 3); i++) {
                let arr = element.children.slice(i * 3, i * 3 + 3)
                if (arr.length > 0) {
                  element.childFormatList.push(arr)
                }
              }
            }
          })
          let childFormatList = []
          for (let i = 0; i < Math.ceil(allList.length / 3); i++) {
            let arr = allList.slice(i * 3, i * 3 + 3)
            if (arr.length > 0) {
              childFormatList.push(arr)
            }
          }
          soluList = soluList.reverse()
          if (allList.length) {
            soluList.push({
              name: '全部',
              id: 0,
              children: allList,
              childFormatList: childFormatList
            })
          }

          this.soluIndex = soluList.length - 1
          this.soluList = soluList
        })
    },
    chooseSolu (index) {
      this.soluIndex = index

      // console.log(this.$refs.solutionRef.swiper)
      // this.$refs.solutionRef.swiper.init()
    },
    goPlanList () {
      this.$router.push({ name: 'planList' })
    },
    goServiceList () {
      this.$router.push({ name: 'serviceList' })
    },
    goPanicBuying () {
      if (this.promotionCount > 1) {
        // 同时存在多个活动
        this.$router.push({ name: 'seckillList' })
      } else {
        this.$router.push({
          name: 'seckillDetail',
          query: { id: this.promotionId }
        })
      }
    },
    // 服务取孩子
    serviceAllChildren (list) {
      let arr = []
      if (list instanceof Array) {
        list.forEach((item) => {
          if (item.children instanceof Array) {
            item.children.forEach((data) => {
              data.partnerName = item.name
              arr.push(data)
            })
          }
        })
      }
      return arr
    },
    get5sDetail (item) {
      // 0：不跳，1：跳外部链接，2：跳自己的content，3：跳活动页面
      // let target = (e && e.target) || (window.event && window.event.srcElement)
      // this.$router.push({ name: '5sDetail', query: { id: id } })
      // let temp = this.fiveSDataList.filter(item => {
      //   return item.id === id
      // })
      // if (temp.length) {
      //   if (temp[0].jump === '1' || temp[0].jump === '3'){
      //     openOther(decodeURIComponent(temp[0].httpAddress), true)
      //   } else if (temp[0].jump === '2' && temp[0].contect && temp[0].contect.length) {
      //     this.$router.push({ name: '5sDetail', query: { id: id } })
      //   }
      // }
      if (
        item.httpAddress !== '' &&
        item.httpAddress !== null &&
        item.httpAddress !== undefined
      ) {
        if (item.jump === '1') {
          openOther(item.httpAddress, true)
        } else if (item.jump === '2' || item.jump === '3') {
          let name = item.httpAddress.split('?')[0]
          let id = item.httpAddress.split('?')[1].split('=')[1]
          this.$router.push({ name: name, query: { id: id } })
        }
      }
      // openOther(item.httpAddress, true)
      // window.open(item.httpAddress)
    },
    // 点击轮播跳转
    chooseRouter (e) {
      let obj = e.target.dataset
      if (obj.key === '5s' && obj.id) {
        this.get5sDetail(obj.id)
      } else if (obj.key === 'solu') {
        // homePageSolution(obj.name)
        this.planDetail(obj.index, obj.inds)
      } else if (obj.key === 'service') {
        // professionalServices(obj.name)
        this.serviceDetail(obj.index, obj.inds)
      } else if (obj.key === 'good') {
        if (obj.spuid && obj.spuid !== '') {
          this.goodDetail(obj.spuid, obj.name)
        }
      }
    },
    chooseCervice (index) {
      this.serviceIndex = index
    },
    showFirstFloor (index) {
      let catGoodData =
        this.homepageList[index].homePageCategoryCommodityVoList
      let showIndex = this.homepageList[index].homeOneTabIndex
      return (
        catGoodData &&
        catGoodData.length &&
        (((showIndex === -1 || !showIndex) &&
          catGoodData[0] &&
          catGoodData[0].children &&
          catGoodData[0].children.length) ||
          (showIndex !== -1 &&
            catGoodData[showIndex] &&
            catGoodData[showIndex].children &&
            catGoodData[showIndex].children.length))
      )
    },
    planDetail (soluIndex, index, id, sceneId) {
      if (sceneId) {
        this.$router.push({ name: 'Scene', query: { sceneId } })
        return
      }
      let params = {
        title:
          soluIndex === this.soluList.length - 1
            ? this.soluList[soluIndex].name
            : this.soluList[soluIndex].children[index].parName,
        id: this.soluList[soluIndex].children[index].solutionId
      }
      this.$router.push({ name: 'planContent', query: params })
    },
    showFirstGoods (item) {
      let catGoodData = item.homePageCategoryCommodityVoList
      if (!(catGoodData && catGoodData.length)) {
        return []
      }
      let num = item.templateCode === 1 ? 4 : 8
      if (item.homeOneTabIndex && item.homeOneTabIndex > -1) {
        return catGoodData[item.homeOneTabIndex].children &&
          catGoodData[item.homeOneTabIndex].children.length
          ? catGoodData[item.homeOneTabIndex].children.slice(0, num)
          : []
      } else {
        return catGoodData[0].children && catGoodData[0].children.length
          ? catGoodData[0].children.slice(0, num)
          : []
      }
    },
    // 获取公告
    getWebAnnouncement () {
      this.$http
        .get('/front/integratedManagement/web-announcement/getWebAnnouncementList')
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.managment.webAnnouncement = res.data && res.data[0]
          }
        })
    }
  },
  components: {
    swiper,
    swiperSlide,
    GoodPrice
  },
  computed: {
    showService () {
      return (
        this.serviceIndex > -1 &&
        this.serviceList[this.serviceIndex] &&
        this.serviceList[this.serviceIndex].children
      )
    }
  },
  mounted () {
    this.$http
      .get(`/front/cross/commodity-user/app/category-list`)
      .then(({ data: res }) => {
        this.allmenuList = res.data.foregroundCategoryList || []
        this.$store.commit(
          'setCategoryMenuList',
          res.data.foregroundCategoryList || []
        )
      })
      .catch(() => {})

    this.get5s()
    this.getBestSellersType()
    this.getBrandList()
    this.getHomepageList()
    this.getPanicBuyingList()
    this.getAllSerivce()
    this.getAllSolu()
    let _this = this
    this.swiperOption.on.click = function (e) {
      _this.chooseRouter(e)
    }
    this.swiperOptionSer.on.click = function (e) {
      _this.chooseRouter(e)
    }
    this.getWebAnnouncement()
    document.addEventListener('scroll', this.getVisible)
  },
  destroyed () {
    document.removeEventListener('scroll', this.getVisible)
  }
}
</script>
<style>
.allHome .el-card__body {
  padding: 0 !important;
}
</style>
<style lang="scss" scoped>
/deep/ .price {
  margin-top: 10px;
  color: #e64c3a;
  font-weight: bold;
  .price-int {
    font-size: 20px;
  }
  .price-point {
    font-size: 10px;
  }
}
.demo111 {
  width: 100%;
  height: 443px;
  position: relative;
  cursor: pointer;
  /* background: url('/static/img/a.png'); */
}
.demo111 img {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
}
div::-webkit-scrollbar {
  width: 8px;
  height: 10px;
  /**/
}
div::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
div::-webkit-scrollbar-thumb {
  background: #3d8bd4;
  border-radius: 10px;
}
div::-webkit-scrollbar-thumb:hover {
  background: rgb(139, 176, 231);
}
div::-webkit-scrollbar-corner {
  background: #d81ebf;
}
.menu-left {
  height: 500px;
  width: 200px;
  float: left;
  /* background-color: rgba(0, 0, 0, 0.55); */
  position: relative;
  z-index: 11;
  color: black;
  overflow: hiidden;
  border-bottom: 1px solid #d81ebf;
  border-right: 1px solid #d81ebf;
  border-left: 1px solid #d81ebf;
}
.menu-right {
  height: 400px;
  width: 947px;
  padding: 20px;
  padding-top: 10px;
  background-color: white;
  position: absolute;
  left: 200px;
  z-index: 11;
  color: rgb(100, 98, 98);
  overflow-y: auto;
}
.el-card {
  border: none;
  border-radius: 0;
}
.firstlelve {
  height: 41.2px;
  line-height: 41.2px;
  padding-left: 37px;
  font-size: 14px;
}
// .firstlelve2 {
//   background: rgb(207, 208, 228, 0.5);
//   color: #3d8bd4;
//   opacity: 1;
//   font-weight: bold;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
// }
.dt {
  width: 50px;
  height: auto;
  position: fixed;
  z-index: 10;
  background: #ffffff;
  border-radius: 6px;
  top: 50%;
  margin-top: -225px;

  @for $i from 0 to 12 {
    &.a#{$i}{
      a {
        &:nth-child(#{$i+1}) {
          .dt-name {
            background: #1d65a8;
            color: #ffffff;
          }
        }
      }
    }
  }
}
.dt-name {
  margin-left: 5px;
  width: 40px;
  height: 50px;
  border-bottom: 1px #eeeeee solid;
  line-height: 20px;
  color: #666;
  text-align: center;
  padding-top: 5px;
  overflow: hidden;
  transition: background 0.15s ease-out 0s;
}
.dt-up {
  margin-left: 5px;
  width: 40px;
  height: 50px;
  border-bottom: 1px #eeeeee solid;
  line-height: 20px;
  color: #666;
  text-align: center;
  padding-top: 5px;
  overflow: hidden;
}
.dt-name:hover {
  background: #1d65a8;
  color: #ffffff;
}

.dting {
  background: #1d65a8;
  color: #ffffff;
}
.banner {
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.07);
  width: 937px;
  height: 443px;
  margin: 10px 0 0 245px;
  .small {
    width: 937px;
    height: 443px;
    background-position: center;
    background-size: 100%;
  }
}
.titleMart {
  margin-top: 20px;
  margin-bottom: 10px;
}

.plan {
  line-height: 35px;
  margin-left: 20px;
  padding: 0px 10px;
  color: #333333;
  margin-top: 20px;
  display: block;
  // width: 100px;
  height: 35px;
  text-align: center;
  float: right;
  overflow: hidden;
}

.plan:hover {
  background: #1d65a8;
  color: #ffffff;
  cursor: pointer;
}
.planac {
  background: #1d65a8;
  color: #ffffff;
  cursor: pointer;
}
.answerMore:hover {
  background: #1d65a8;
  color: white;
}
.plan a:hover {
  color: #ffffff !important;
}
.plan-box-m {
  padding: 20px 10px 0px 10px;
}
.imgBox {
  overflow: hidden;
}
.plan-box-m img {
  cursor: pointer;
  transition: transform 2s;
}
.plan-box-m img:hover {
  transform: scale(1.5);
}
.plan-title {
  font-size: 18px;
  line-height: 40px;
  width: 100%;
  color: #333333;
}

.plan-stitle {
  font-size: 12px;
  color: #8a8a8a;
  line-height: 1.5em;
  width: 100%;
  height: 57px;
}
.plan-stitle-border {
  height: 13px;
  width: 100%;
  border-bottom: 1px #d8d8d8 solid;
}
.plan-stitle-over {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  width: 100%;
  /* border: 1px solid red; */
  /* font-size: 30px; */
}
.plan-more {
  width: 99px;
  line-height: 35px;
  padding-left: 10px;
  font-size: 12px;
  text-align: left;
  border: 1px solid #1d65a8;
  color: #1d65a8;
  background: url("~@/assets/img/more.jpg") no-repeat right;
  margin: 20px 0px 60px;
  cursor: pointer;
}
.plan-more:hover {
  background: url("~@/assets/img/more2.png") no-repeat right;
  color: white;
}

.server-more {
  /* margin-top: 30px; */
  text-align: right;
}

.serve {
  width: 1190px;
  height: auto;
  /* margin-top: 20px; */
}

.serve-tab {
  background-color: #dce2e8;
  height: 80px;
  color: #333333;
  border-left: 1px #ffffff solid;
  line-height: 80px;
  text-align: center;
  font-size: 16px;
  user-select: none;
  cursor: pointer;
}
.serve-tab span {
  cursor: pointer;
}
.serve-tabl {
  background-color: #dce2e8;
  height: 80px;
  color: #333333;
  line-height: 80px;
  text-align: center;
  font-size: 16px;
}
.servetabactive {
  background-color: #fff !important;
  height: 80px !important;
  color: #1d65a8 !important;
  border-left: 1px #ffffff solid !important;
  line-height: 80px !important;
  text-align: center !important;
  border-top: 3px #1d65a8 solid !important;
  font-size: 22px !important;
  /* font-weight: bold; */
}
.servetabactivel {
  background-color: #fff !important;
  height: 80px !important;
  color: #1d65a8 !important;
  line-height: 80px !important;
  text-align: center !important;
  border-top: 3px #1d65a8 solid !important;
  font-size: 22px !important;
  /* font-weight: bold; */
}
.serve-tab-1 {
  margin-left: -1px;
}

.serve-box {
  padding: 20px;
}

.serve-box-img {
  width: 265px;
  height: 184px;
  margin-right: 30px;
}

.serve-box-title {
  font-size: 20px;
  color: #333333;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
}
.serve-box-title-span {
  white-space: nowrap;
  width: 73%;
  height: 23px;
  line-height: 23px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
}
.serve-box-des-span {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  max-height: 62px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 73%;
}
.serve-box-con {
  font-size: 14px;
  color: #999;
  width: 100%;
  line-height: 1.5em;
  margin-top: 10px;
  margin-bottom: 10px;
}

.serve-box-more {
  color: #1d65a8;
  cursor: pointer;
}

.serve-box-more a {
  color: #1d65a8;
}

.serve-box-more a:hover {
  color: #1d65a8;
}

.rem {
  width: 20% !important;
  height: 291px;
}

.rem-title {
  font-size: 20px;
  line-height: 30px;
  color: #333333;
  margin: 20px 15px 5px;
}

.rem-stitle {
  color: #999999;
  line-height: 40px;
  margin: 0px 15px;
}

.rem-img {
  height: 121px;
  width: 90px;
  padding-top: 10px;
}

.rems {
  width: 20% !important;
  height: 141px;
  margin-bottom: 10px;
}

.rems-box {
  width: 134px;
}

.rems-stitle {
  color: #999999;
  line-height: 40px;
  padding-left: 15px !important;
}

.rems-title {
  text-align: left;
  line-height: 22px;
  font-size: 16px;
  color: #333333;
  height: 22px;
  margin-top: 20px;
  color: #333333;
  padding-left: 20px !important;
}
.rems-desc {
  margin-top: 10px;
  text-align: left;
  line-height: 1.5em;
  font-size: 12px;
  color: #999999;
  height: 17px;
  padding-left: 20px !important;
}

.xianc1 {
  background: url("~@/assets/img/xcyb.jpg");
  width: 289px;
  height: 350px;
  overflow-y: auto;
}
.xiancltitle {
  padding-left: 20px;
  line-height: 50px;
  color: #ffffff;
}
.xiancltitle:hover {
  background: url("~@/assets/img/xcl.jpg") no-repeat;
  cursor: pointer;
}
.xiancltitleac {
  background: url("~@/assets/img/xcl.jpg") no-repeat;
}
.xianc2 {
  width: 225px;
  border-left: 1px #f9f9f9 solid;
  background-color: #ffffff;
}

.xianc2-pic {
  width: 220px;
  height: 180px;
  margin: 10px auto;
  position: relative;
}

.xianc2-title {
  height: 40px;
  line-height: 40px;
  padding: 0px 8px;
  word-break: break-word;
  white-space: pre-wrap;
}

.xianc2-xilie {
  background: #f5f5f5;
  border-radius: 2px;
  width: 90px;
  height: 20px;
  font-size: 12px;
  color: #999999;
  line-height: 20px;
  text-align: center;
  margin: 5px 0px 0px 10px;
}

.xianc2-dl {
  background: #ffffff;
  border: 1px solid #ff8f3b;
  border-radius: 2px;
  width: 90px;
  font-size: 12px;
  height: 20px;
  text-align: center;
  margin: 5px 10px 0px 0px;
  color: #ff6a1f;
}

.xs {
  float: left;
  margin: 10px 0px 8px 10px;
}

.xclogo {
  width: 13.6%;
  height: 80px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: #ffffff;
  margin-top: 10px;
  margin-left: 3px;
  margin-right: 5px;
}

.xclogo img {
  max-width: 100%;
  max-height: 100%;
  padding: 5px;
}

.fmgg {
  background: #dce2e8;
  width: 215px;
  height: 394px;
}

.fmgg-title {
  font-size: 20px;
  padding-top: 20px;
  margin-bottom: 15px;
  margin-left: 10px;
}

.fmgg-stitle {
  color: #333333;
  margin-bottom: 15px;
  margin-left: 10px;
  margin-right: 10px;
}

.fmgg-l {
  background: #2c5ea2;
  height: 31px;
  padding: 0px 10px;
  width: auto;
  color: #ffffff;
  line-height: 31px;
  margin-left: 10px;
  display: -webkit-inline-box;
}

.fmbox {
  width: 258px;
  height: 192px;
  margin-left: 10px;
  margin-bottom: 10px;
}

.fmbox-title {
  font-size: 16px;
  margin-top: 10px;
  margin-left: 8px;
  line-height: 30px;
}

.fmbox-stitle {
  margin-left: 8px;
  line-height: 30px;
}

.fmbox-l {
  margin-left: 8px;
  line-height: 1.5em;
  font-size: 12px;
  color: #999;
}

.fmlogo {
  width: 160px;
  height: 90px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: #ffffff;
  margin-bottom: 10px;
}

.fmlogo img {
  max-width: 100%;
  max-height: 100%;
  padding: 5px;
  width: 100%;
  height: 100%;
}

.kzl {
  width: 215px;
  height: 632px;
  background-color: #dce2e8;
}

.kel-title {
  font-size: 20px;
  padding-top: 40px;
  margin-bottom: 15px;
  margin-left: 10px;
}

.ker-box {
  width: 243px;
  height: 316px;
  border-left: 1px #f5f5f5 solid;
  background-color: #ffffff;
  border-bottom: 1px #f5f5f5 solid;
  position: relative;
}

.ker-box img {
  // width: 223px;
  width: 100%;
  height: 162px;
  // margin-top: 10px;
  text-align: center;
  // margin-left: 9px;
  padding: 10px 9px;
}

.ker-title {
  height: 40px;
  line-height: 40px;
  color: #333333;
  margin-left: 8px;
  word-break: break-word;
  white-space: pre-wrap;
}

.ker-stitle {
  line-height: 40px;
  padding: 10px 10px;
  color: #999999;
}

.ker-sc {
  width: 40%;
  float: left;
  color: #999999;
  line-height: 40px;
  margin: 0 8px;
}

.zhishil {
  height: 497px;
  padding: 20px 10px 10px 10px;
}

.zhishil-title {
  margin-bottom: 20px;
  font-size: 18px;
  color: #262626;
}

.zhishil-list {
  width: 100%;
  line-height: 40px;
  color: #262626;
}

.pplogo {
  width: 14.28%;
  height: 120px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: #ffffff;
  margin-top: 8px;
}

.pplogo img {
  max-width: 100%;
  max-height: 100%;
  padding: 5px;
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E");
  right: 10px;
  left: auto;
  border: 1px rgb(0, 122, 255) solid;
  padding: 15px 20px;
  background-size: 20px 20px;
  margin-top: 30px;
}
.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E");
  right: 70px;
  border: 1px rgb(0, 122, 255) solid;
  padding: 15px 20px;
  background-size: 20px 20px;
  margin-top: 30px;
  left: inherit;
}
.dt {
  width: 50px;
  height: auto;
  position: fixed;
  z-index: 10;
  background: #ffffff;
  border-radius: 6px;
  top: 50%;
  margin-top: -225px;
}
.dt-name {
  margin-left: 5px;
  width: 40px;
  height: 50px;
  border-bottom: 1px #eeeeee solid;
  line-height: 20px;
  color: #666;
  text-align: center;
  padding-top: 5px;
  overflow: hidden;
}
.dt-up {
  margin-left: 5px;
  width: 40px;
  height: 50px;
  border-bottom: 1px #eeeeee solid;
  line-height: 20px;
  color: #666;
  text-align: center;
  padding-top: 5px;
  overflow: hidden;
}
.dt-name:hover {
  background: #1d65a8;
  color: #ffffff;
}
.xcyb-img {
  width: 100px;
  height: 170px;
  margin-top: 10px;
}
.imgAuto {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
    padding: 5px;
    width: 100%;
    height: 138px;
  }
}
.dting {
  background: #1d65a8;
  color: #ffffff;
}
/* 知识社区 */
.know-header {
  margin: 30px 0px 10px 0;
  text-align: left;
  line-height: 37px;
  font-size: 26px;
  color: #262626;
  height: 37px;
}
.know-header-remark {
  text-align: left;
  height: 37px;
  line-height: 37px;
  font-size: 14px;
  color: #acacac;
}
.know-body {
  display: flex;
}
.know-word {
  padding: 20px 29px;
  background-color: #fff;
  width: 320px;
}
.know-word-title {
  display: inline-block;
  text-align: left;
  line-height: 25px;
  font-size: 18px;
  color: #262626;
  width: 159px;
  height: 25px;
  margin-bottom: 20px;
}
.know-word-detail {
  height: 40px;
  line-height: 40px;
  text-align: left;
  font-size: 14px;
  color: #262626;
  display: flex;
}
.know-word-detail-downLoad {
  text-align: right;
  line-height: 40px;
  font-size: 14px;
  color: #2c5ea2;
  line-height: 40px;
  width: 43px;
  cursor: pointer;
  /* margin-left: 23px; */
}
.know-word-detail-name {
  width: 150px;
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.know-other {
  margin-left: 10px;
  width: 100%;
}
.know-video-list {
  margin-left: 10px;
}
.know-video {
  padding: 20px 29px 10px 29px;
  background-color: #fff;
}
.know-video-title {
  text-align: left;
  line-height: 25px;
  font-size: 18px;
  color: #262626;
  height: 25px;
  width: 850px;
  display: inline-block;
}
.know-video-list {
  margin-top: 20px;
  display: flex;
}
.know-video-detail {
  margin-right: 40px;
  position: relative;
  cursor: pointer;
}
.know-video-detail-title {
  margin-top: 10px;
  text-align: left;
  line-height: 30px;
  font-size: 16px;
  color: #262626;
  height: 30px;
  width: 255px;
}
.k-video-play {
  width: 38.7px;
  height: 38.7px;
  position: absolute;
  top: 60px;
  left: 108px;
}
.k-video-num {
  width: 100%;
  height: 20px;
  position: absolute;
  top: 140px;
  left: 0;
  background-color: rgba(255, 255, 255, 0.4);
  text-align: right;
  color: #fff;
}
.k-video-text {
  text-align: right;
  display: flex;
  line-height: 1.5em;
}
.k-video-text img {
  height: 24px;
  width: 24px;
  border-radius: 12px;
  overflow: hidden;
  margin-right: 10px;
}
.video-author {
  margin-right: 5px;
  color: #999;
  width: 120px;
  text-align: left;
}
.video-author img {
  border-radius: 12px;
}
.video-time {
  padding-left: 0px;
  color: #999;
  /* width:100%; */
}
.know-export {
  margin-top: 10px;
  background-color: #fff;
  padding: 20px 29px;
}
.know-export-title {
  display: flex;
  text-align: left;
  line-height: 25px;
  font-size: 18px;
  color: #262626;
  height: 25px;
  width: 100%;
}
.know-export-category {
  width: 100%;
  text-align: right;
  font-size: 14px;
}
.know-export-category span {
  text-align: center;
  padding-right: 10px;
  padding-left: 10px;
  cursor: pointer;
}
.exportTitle:hover {
  background: #1d65a8;
  color: white;
}
.know-export-list {
  margin: 20px 0;
}
.know-export-detail {
  display: flex;
}
.export-detail {
  display: flex;
  width: 50%;
  padding: 20px 20px;
  margin-left: 10px;
  margin-top: 28px;
}
.export-detail img {
  border-radius: 25px;
  overflow: hidden;
}
.export-detail-info {
  padding-left: 10px;
}
.export-detail-info-name {
  max-width: 120px;
  text-align: left;
  line-height: 25px;
  font-size: 18px;
  color: #262626;
  height: 28px;
  padding-bottom: 3px;
  word-break: break-word;
  white-space: pre-wrap;
}
.export-detail-info-desc {
  width: 120px;
  text-align: left;
  line-height: 20px;
  font-size: 14px;
  color: #999999;
  height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.export-ask-but {
  padding: 7px 17px;
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  color: #2c5ea2;
  /* height: 50px; */
  border: 1px solid #2c5ea2;
  cursor: pointer;
}
.export-ask-but:hover {
  background: #1d65a8;
  color: #ffffff;
}
.other-more {
  display: inline-block;
  width: 30px;
  height: 25px;
  line-height: 25px;
  margin-bottom: 25px;
  text-align: center;
}
.moreBox {
  display: inline-block;
  width: 50px;
  height: 25px;
  line-height: 25px;
}
.moreBox:hover {
  background: #2c5ea2;
  color: white;
}
.consult {
  display: block;
  margin-left: 5px;
  width: 40px;
  height: 50px;
  // border-bottom: 1px #eeeeee solid;
  line-height: 20px;
  color: #666 !important;
  text-align: center;
  padding-top: 5px;
  overflow: hidden;
  text-decoration: none;
}
.consult:hover {
  background: #1d65a8;
  color: #ffffff !important;
}
/* 抢购活动*/
.panicBuying {
  display: flex;
  margin-top: 20px;
}
.panicBuying .panicBuying-sign {
  position: relative;
  cursor: pointer;
  width: 209px;
  height: 260px;
  flex-shrink: 1;
}
.panicBuying .panicBuying-sign .panicBuying-sign-time {
  position: absolute;
  top: 0;
  left: 0;
  height: 40px;
  width: 100%;
  background: #2f3430;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-size: 14px;
}
.panicBuying .panicBuying-car {
  /* margin-left: 10px; */
  width: 100%;
  height: 100%;
  flex-grow: 1;
}
.panicBuying .panicBuying-car .panicBuying-carousel {
  width: 100%;
  height: 100%;
  /* flex-grow: 1; */
}
.panicBuying-car .el-carousel {
  overflow: hidden;
  height: 260px;
  background-color: #fff;
}

.panicBuying-car .el-carousel__item {
  height: 260px;
}
.goodInfo {
  padding: 10px 20px;
  position: relative;
}
.goodInfo-right-border {
  position: absolute;
  top: 60px;
  left: -10px;
  width: 2px;
  height: 120px;
  border-left: 1px solid #eee;
  /* height: 300px; */
  /* width: 300px; */
}
/* .goodInfo-right-border:before {
  content:"";
  position:absolute;
  left:0;
  top:20px;
  width:1px;
  height:150px;
  border-right: 1px solid red;
} */
.goodInfo .goodInfo-img {
  cursor: pointer;
  width: 203px;
  height: 152px;
  margin: 12px auto;
}
.goodInfo .goodName {
  line-height: 17px;
  font-size: 12px;
  color: #333333;
  margin: 10px 0;
}
.panicBuying-price {
  border: 1px solid #e02a21;
  border-left: none;
  height: 28px;
}
.price-left {
  display: inline-block;
  color: #fff;
  height: 0;
  width: 50%;
  line-height: 28px;
  padding-left: 5px;
  border-width: 0px 20px 27px 0px;
  border-style: solid solid solid solid;
  border-color: transparent transparent #e02a21;
  text-align: left;
}
.price-left .price-left-amount {
  font-size: 18px;
}
.price-right {
  width: 45%;
  display: inline-block;
  text-align: right;
  text-decoration: line-through;
  color: #999999;
}
.price-right .price-right-amount {
  font-size: 14px;
}
</style>
<style lang="scss" scoped>
.banner {
  .el-carousel__container {
    // height: 390px;
  }
}
.panicBuying-car .el-carousel .el-carousel__container {
  height: 260px !important;
}
.panicBuying-car
  .el-carousel
  .el-carousel__container
  .el-carousel__arrow--left {
  left: 0;
}
.panicBuying-car
  .el-carousel
  .el-carousel__container
  .el-carousel__arrow--right {
  right: 0;
}
.webAnnouncement{
  padding-left: 10px;
  padding-right: 10px;
  background: #fff;
  line-height: 40px;
  margin-top: 10px;
  cursor: pointer;
}
</style>
